// extracted by mini-css-extract-plugin
module.exports = {"datesContainer":"Dates_datesContainer__3VZYT"};